import { Inject, Injectable } from '@angular/core';
import { TableService } from '../../../_Core/shared/crud-table';
// import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpHeaders } from '@angular/common/http';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { map } from 'rxjs/operators';
import { EnvService } from 'src/app/service/env.service';

@Injectable({
  providedIn: 'root'
})
export class HospitalService extends TableService<any> {

  API_URL = `${this.environment.apiUrl}/HospitalInfo`;
  constructor(@Inject(HttpClient) http, private spinner: NgxSpinnerService,private translationService: TranslationService,private environment : EnvService) {
    super(http);
  }

  Header() {
    let header = new HttpHeaders().set("Accept-Language", this.translationService.getSelectedLanguage());
    const options = {
      headers: header,
    };
    return options;
  }
  HeaderApiSecurityKey() {
    let header = new HttpHeaders().set("Authorization","Bearer " + this.environment.APIAuthorizationKey).set("Accept-Language", this.translationService.getSelectedLanguage());
    const options = {
      headers: header
    };
    return options;
  }
  GetHospitalContacts(): Observable<any> {
    return this.GetItemByParam(null,this.API_URL + "/GetHospitalContacts",this.Header())
  }
  GetHospitalBlogs(): Observable<any> {
    return this.GetItemByParam(null,this.API_URL + "/GetHospitalBlogs",this.Header())
  }
  GetHospitalNews(): Observable<any> {
    return this.GetItemByParam(null,this.API_URL + "/GetHospitalNews",this.Header())
  }
  GetHospitalPartners(): Observable<any> {
    return this.GetItemByParam(null,this.API_URL + "/GetHospitalPartners",this.Header())
  }
  GetHospitalDepartments(): Observable<any> {
    return this.GetItemByParam(null,this.API_URL + "/GetHospitalDepartments",this.Header()).pipe(
      map((response: any) => {
        return response.data
      })
    );
  }
  GetAllDoctorsByDepartmentId(DepartmentId): Observable<any> {
    return this.GetItemByParam(DepartmentId,this.API_URL + "/GetAllDoctorsByDepartmentId?DepartmentId="+DepartmentId,this.Header()).pipe(
      map((response: any) => {
        return response.data
      })
    );
  }

  GetAllBoardTeamByTypeId(TypeId): Observable<any> {
    return this.GetItemByParam(TypeId,this.API_URL + "/GetAllBoardTeamByTypeId?TypeId="+TypeId,this.Header()).pipe(
      map((response: any) => {
        return response.data
      })
    );
  }

   GetAllHospitalsByTypeId(TypeId): Observable<any> {
    return this.GetItemByParam(TypeId,this.API_URL + "/GetAllHospitalsByTypeId?TypeId="+TypeId,this.Header()).pipe(
      map((response: any) => {
        return response.data
      })
    );
  }
  GetDoctorSlots(DoctorId,date): Observable<any> {
    return this.GetItemByParam(DoctorId,this.API_URL + "/GetDoctorSlots?DoctorId="+DoctorId+"&date="+date,this.HeaderApiSecurityKey());
  }
  GetPatientByPassportNoAndMobile(PassportNo,Mobile): Observable<any> {
    return this.GetItemByParam(PassportNo,this.environment.apiUrl + "/Auth/GetPatientByPassportNoAndMobile?PassportNo="+PassportNo+"&Mobile="+Mobile,this.Header())
  }
  GetCongratsCategories(): Observable<any> {
    return this.GetItemByParam(null,this.API_URL + "/GetCongratsCategories",this.Header()).pipe(
      map((response: any) => {
        return response.data
      })
    );
  }
  GetCongratsImages(ApiCongratsCategoryId): Observable<any> {
    return this.GetItemByParam(null,this.API_URL + "/GetCongratsImages?ApiCongratsCategoryId="+ApiCongratsCategoryId,this.Header())
  }
  GetVerifyReportInfo(PatientId,VisitId): Observable<any> {
    return this.GetItemByParam(PatientId,this.API_URL + "/GetVerifyReportInfo?PatientId="+PatientId+"&VisitId="+VisitId,this.HeaderApiSecurityKey());
  }
  GetAllSurveySectionByVisitType(VisitId): Observable<any> {
    return this.GetItemByParam(VisitId,this.environment.apiUrl + "/Survey/GetAllSurveySectionByVisitType?VisitId="+VisitId,this.HeaderApiSecurityKey());
  }
  AddEditSurveyResult(apiSurveyResult): Observable<any> {
    return this.http.post(this.environment.apiUrl + "/Survey/AddEditSurveyResult",apiSurveyResult,this.HeaderApiSecurityKey());
  }
  GetSurveyResultByID(VisitId): Observable<any> {
    return this.GetItemByParam(VisitId,this.environment.apiUrl + "/Survey/GetSurveyResultByID?VisitId="+VisitId,this.HeaderApiSecurityKey());
  }
  GetPrescription(VisitId): Observable<any> {
    return this.GetItemByParam(VisitId,this.API_URL + "/GetPrescription?VisitId="+VisitId,this.HeaderApiSecurityKey());
  }
  AddMedicineLog(MedicineLog): Observable<any> {
    return this.http.post(this.API_URL  + "/AddMedicineLog",MedicineLog,this.HeaderApiSecurityKey());
  }
  GetAllOffers(): Observable<any> {
    return this.GetItemByParam(null,this.environment.apiUrl + "/Offer/GetAllOffers",this.HeaderApiSecurityKey());
  }
  GetAllOffersBySectionId(SectionId): Observable<any> {
    return this.GetItemByParam(SectionId,this.environment.apiUrl+ "/Offer/GetAllOffersBySectionId?SectionId="+SectionId,this.HeaderApiSecurityKey()).pipe(
      map((response: any) => {
        return response.data
      })
    );
  }
  AddOfferRequest(OfferRequest): Observable<any> {
    return this.http.post(this.environment.apiUrl + "/Offer/AddOfferRequest",OfferRequest,this.HeaderApiSecurityKey());
  }
  AddOfferTrack(OfferTrack): Observable<any> {
    return this.http.post(this.environment.apiUrl + "/Offer/AddOfferTrack",OfferTrack,this.HeaderApiSecurityKey());
  }
  AddOfferLog(OfferLog): Observable<any> {
    return this.http.post(this.environment.apiUrl + "/Offer/AddOfferLog",OfferLog,this.HeaderApiSecurityKey());
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
  showLoader() {
    this.spinner.show();
  }
  hideLoader() {
    this.spinner.hide();
  }
}
